import {atom, selector} from "recoil";

export const openDateState = atom({
    key: 'openDateState',
    default: {
        gnrScheSttDt: "",
        gnrScheEndDt: ""
    },
});

export const userState = atom({
    key: 'userState',
    default: {},
});

export const agreeDataState = atom({
    key: 'agreeDataState',
    default: [],
});

export const surveyDataState = atom({
    key: 'surveyDataState',
    default: [],
});

export const menuDataState = atom({
    key: 'menuDataState',
    default: {},
});

export const answerState = atom({
    key: 'answerState',
    default: {},
});

export const familyState = atom({
    key: 'familyState',
    default: [],
});

export const rentState = atom({
    key: 'rentState',
    default: {
        house: {},
        commercial: {},
        houseChecklist: [],
        commercialChecklist: []
    },
});

export const selectedMenuItemState = atom({
    key: 'selectedMenuItemState',
    default: "",
});

export const menuCheckSelector = selector({
    key: "menuCheckSelector",
    get: ({ get }) => {
        const menu = get(menuDataState);
        const selectedItem = get(selectedMenuItemState);
        if (selectedItem !== "") {
            return menu[selectedItem].isChecked;
        }
        return false;
    },
    set: ({ get, set }, newValue) => {
        const menu = get(menuDataState);
        const selectedItem = get(selectedMenuItemState);
        if (selectedItem !== "") {
            const newState = {
                ...menu,
                [selectedItem]: {
                    ...menu[selectedItem],
                    isChecked: newValue
                }
            }
            set(menuDataState, newState);
        }
    },
});

export const stepState = atom({
    key: 'stepState',
    default: 0,
});

// 이자/배당소득 파일
export const intFileState = atom({
    key: 'intFileState',
    default: [],
});

// 임대소득관련 첨부파일
export const rentFileState = atom({
    key: 'rentFileState',
    default: [],
});

// 사업소득 첨부파일
export const bizFileState = atom({
    key: 'bizFileState',
    default: [],
});

// 기타소득 첨부파일
export const etcFileState = atom({
    key: 'etcFileState',
    default: [],
});

// 연말정산 간소화자료 첨부파일
export const simpleFileState = atom({
    key: 'simpleFileState',
    default: [],
});

// 기타 공제자료 첨부파일
export const etcReturnFileState = atom({
    key: 'etcReturnFileState',
    default: [],
});


export const seqState = atom({
    key: 'seqState',
    default: "",
});

export const familyGridTitle = atom( {
  key: "familyGridTitle",
  default: "부양가족으로 신청하실 가족정보를 입력하세요.",
})

